module.exports = __webpack_public_path__ + "assets/img/banner-patentes-540.jpg";